export class RepresentacaoVO {

  siglaSistema: string;
  cnpj: string;
  loginRepresentante: string;
  perfis: string[];
}
